import { TextField } from '@mui/material';
import { UOSSU_PDD } from '../userOrderShipmentStatusUpdate.classes';

function PackageDataDispatcher({
    textBoxDesiState,
    textBoxPackageCountState,
    setTextBoxDesi,
    setTextBoxPackageCount,
}: any) {
    return (
        <>
            <TextField
                className={UOSSU_PDD.inputTextDesi}
                fullWidth
                style={{ marginBottom: '1rem', maxWidth: '300px', marginTop: '1rem' }}
                value={textBoxDesiState}
                onChange={(e) => setTextBoxDesi(e.target.value)}
                label="Desi"
                variant="outlined"
                type="number"
            />
            <TextField
                className={UOSSU_PDD.inputTextPackageCount}
                fullWidth
                style={{ marginBottom: '1rem', maxWidth: '300px', marginTop: '1rem' }}
                value={textBoxPackageCountState}
                onChange={(e) => setTextBoxPackageCount(e.target.value)}
                label="Paket Sayısı"
                variant="outlined"
                type="number"
            />
        </>
    );
}

export default PackageDataDispatcher;
